/**
 * German catalogue — the reference language, and the only place in the app that
 * carries German prose. The wording is the one pilots know from the paper form
 * (LBA fsm 1/87), copied verbatim from the single-file predecessor.
 *
 * The strings themselves live in `i18n/de/*.ts`, one module per area of the app,
 * so two people adding keys to two panes do not collide in one 800-line file.
 * This file only merges them, and `en.ts` is typed against the result, so a
 * forgotten key is a type error rather than a `??` in the browser.
 *
 * A prefix belongs to exactly one module (see `docs/design/aether-ux.md` §15.2);
 * `test/i18n.test.ts` fails if two modules claim the same key, because a spread
 * lets the last one win silently.
 */
import { aircraft } from './de/aircraft';
import { auth } from './de/auth';
import { common } from './de/common';
import { exportKeys } from './de/export';
import { flight } from './de/flight';
import { flights } from './de/flights';
import { form } from './de/form';
import { map } from './de/map';
import { navlog } from './de/navlog';
import { settings } from './de/settings';
import { terrain } from './de/terrain';
import { weather } from './de/weather';

export const MODULES_DE = [
  common, flights, flight, navlog, weather, terrain, exportKeys, aircraft, settings, auth, map, form,
] as const;

export const de = {
  ...common,
  ...flights,
  ...flight,
  ...navlog,
  ...weather,
  ...terrain,
  ...exportKeys,
  ...aircraft,
  ...settings,
  ...auth,
  ...map,
  ...form,
} as const;
